module.exports = __webpack_public_path__ + "img/dina.ce234ae5.png";